import React, { useState } from 'react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { getClassMeets, newMeet } from '../../api/class';

const Events = ({ user, cid }) => {
    const initialVals = {
        topic: 'MeetT',
        message: 'MeetM',
        on_date: '',
        created_by: user._id,
        time: ''
    }
    const [values, setValues] = useState(initialVals)
    const [meets, setMeets] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        loadMeets()
    }, [])

    const loadMeets = () => {
        getClassMeets(cid)
            .then(res => {
                setMeets(res.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
            })
    }

    const handleChange = e => {
        if (e.target.name === 'on_date' && new Date(e.target.value) <= new Date()) {
            setValues({ ...values, [e.target.name]: initialVals.on_date })
            toast.error('Meet date should be grater')
        } else
            setValues({ ...values, [e.target.name]: e.target.value })
    }

    const handleSubmit = e => {
        e.preventDefault()
        values.time = new Date()
        // console.log(values)
        newMeet(cid, user.token, values)
            .then(res => {
                setMeets(res.data)
            })
            .catch(err => {
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
            })
    }

    const displayDate = (date) => {
        return `${date.getDate()}/${(date.getMonth() + 1)}/${date.getFullYear()}`
    }

    const isToday = (someDate) => {
        const today = new Date()
        return (someDate.getDate() == today.getDate() &&
            someDate.getMonth() == today.getMonth() &&
            someDate.getFullYear() == today.getFullYear())
    }

    return (
        <div className="events-of-myclassroom-div">
            <form onSubmit={handleSubmit} className="row g-3">
                <div className="col-sm">
                    <input type="text" value={values.topic} onChange={handleChange} name='topic' className="form-control" placeholder="Title" aria-label="topic" required />
                </div>
                <div className="col-sm-7">
                    <input type="text" value={values.message} onChange={handleChange} name='message' className="form-control" placeholder="Any message" aria-label="message" required />
                </div>
                <div className="col-sm event-date-pick-div">
                    <input type="date" value={values.on_date} onChange={handleChange} name='on_date' required />
                </div>
                <div className="col-sm">
                    <button className="btn btn-primary">Send</button>
                </div>
            </form>
            <div className="my-classroom-meets">
                {
                    loading ? <h1>loading</h1> :
                        (
                            (meets && meets.length) ? (meets.map((each, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', margin: '20px 50px', padding: '30px', border: '1px solid grey' }} className="my-classroom-meet-details">
                                    <h3>{displayDate(new Date(each.on_date))}</h3>
                                    <h3>{each.topic}</h3>
                                    {
                                        isToday(new Date(each.on_date)) ?
                                            (<button className="btn btn-primary">Create</button>) :
                                            (<button className="btn btn-primary">More Detals</button>)
                                    }
                                </div>
                            ))) : ""
                        )
                }
            </div>
        </div>
    );
};

export default Events;